import Ripple from "../../../../../dumb/Ripple";
import {Link} from "../../../../../../router";
import {LINK_BANK_ACCOUNT_CREATE} from "../../../../../../constants/links";
import React from "react";

export default () => (
  <div className="w h layoutRow fxdC jcC aiC abs st0 sl0 bgF0.3 z10" style={{backdropFilter: 'blur(3px)'}}>
    <div className="tc lh24">
      Banks and stablecoins accounts list is empty.<br/>
      Please add at least one to proceed with dashboard process.
    </div>
    <div className="layoutRow mh-5 (ph5)>1">
      <div>
        <Ripple
          component={Link}
          className="layoutRow fvaC fhaC h45 wmin75 mt20 ph20 bs b1 bcC r9 ttU olN
                    f12 fw4 tdN ov dn bc0:h ml20"
          href={LINK_BANK_ACCOUNT_CREATE}
          options={{
            query: {
              type: 'bankAccounts'
            },
          }}
        >Add bank account +</Ripple>
      </div>
      <div>
        <Ripple
          component={Link}
          className="layoutRow fvaC fhaC h45 wmin75 mt20 ph20 bs b1 bcC r9 ttU olN
                    f12 fw4 tdN ov dn bc0:h ml20"
          href={LINK_BANK_ACCOUNT_CREATE}
          options={{
            query: {
              type: 'stablecoinAccounts'
            },
          }}
        >Add stablecoin account +</Ripple>
      </div>
    </div>
  </div>
)
